import Vue from 'vue'
import {options} from './plugins/vuetify'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Interceptors from './interceptors/index'
import './registerServiceWorker'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'
import 'font-awesome/css/font-awesome.css'
import './styles/style.css'
import NProgress from 'vue-nprogress'
import * as VueGoogleMaps from 'vue2-google-maps'

import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'

Vue.use(VueGlide);
const NPoptions = {
    latencyThreshold: 200, // Number of ms before progressbar starts showing, default: 100,
    router: true, // Show progressbar when navigating routes, default: true
    http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, NPoptions);

import Vuetify from "vuetify";

const vuetify = new Vuetify(options);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCpb54b8FB5WVxBDKAYVknsOZWGYNn0V74',
        libraries: 'places,directions', // This is required if you use the Autocomplete plugin
    },
})

Vue.config.productionTip = false
Vue.use(Interceptors)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
